import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { FaArrowLeft, FaEye, FaTrash } from "react-icons/fa";
import moment from "moment";
import { getWalletWithdrawalHistory } from "./services/wallet.services";
import { useNavigate } from "react-router";
import WalletWithdrawReqDelete from "./WalletWithdrawReqDelete";

const WithdrawalHistory = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [deleteID, setDeleteID] = useState(null);
  const withdrawals = useAppSelector(
    (state) => state.wallet.walletWithdrawalHostory
  );
  const loading = useAppSelector((state) => state.wallet.loading);

  useEffect(() => {
    dispatch(getWalletWithdrawalHistory());
  }, []);

  const formatDate = (dateString: string) => {
    return moment(dateString, "DD/MM/YYYY").format("DD MMM YYYY");
  };

  const formatDateTime = (dateString: string) => {
    return dateString
      ? moment(dateString, "DD/MM/YYYY").format("DD MMM YYYY hh:mm A")
      : "-";
  };

  return (
    <>
      <WalletWithdrawReqDelete ID={deleteID} isfromHistory={true} />
      <div className="container py-5">
        <div className="d-flex align-items-center mb-4">
          <button
            onClick={() => navigate(-1)}
            className="btn btn-link me-3"
            style={{
              color: "#00a34d",
              background: "white",
              padding: "8px",
            }}
          >
            <FaArrowLeft size={20} />
          </button>
          <h2 className="mb-0">Withdrawal History</h2>
        </div>
        <div className="card border-0 shadow-sm">
          <div className="card-body p-0">
            {loading ? (
              <div className="text-center py-4">
                <div
                  className="spinner-border"
                  style={{ color: "rgba(205, 200, 36, 1)" }}
                  role="status"
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table align-items-center mb-0">
                  <thead
                    style={{
                      backgroundColor: "#f8f9fa",
                      borderBottom: "2px solid #dee2e6",
                    }}
                  >
                    <tr>
                      <th
                        className="text-uppercase text-dark text-xs ps-4 py-3"
                        style={{ width: "5%", minWidth: "50px" }}
                      >
                        No
                      </th>
                      <th
                        className="text-uppercase text-dark text-xs py-3"
                        style={{ width: "15%", minWidth: "120px" }}
                      >
                        Request Date
                      </th>
                      <th
                        className="text-uppercase text-dark text-xs py-3"
                        style={{ width: "12%", minWidth: "100px" }}
                      >
                        Amount (₹)
                      </th>
                      <th
                        className="text-uppercase text-dark text-xs py-3"
                        style={{ width: "25%", minWidth: "150px" }}
                      >
                        Remarks
                      </th>
                      <th
                        className="text-uppercase text-dark text-xs py-3"
                        style={{ width: "15%", minWidth: "100px" }}
                      >
                        Status
                      </th>
                      <th
                        className="text-uppercase text-dark text-xs py-3"
                        style={{ width: "15%", minWidth: "120px" }}
                      >
                        Withdrawal Date
                      </th>
                      <th
                        className="text-uppercase text-dark text-xs pe-4 py-3"
                        style={{ width: "13%", minWidth: "90px" }}
                      >
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {withdrawals.length > 0 ? (
                      withdrawals.map((withdrawal, index) => (
                        <tr key={withdrawal.ID}>
                          <td className="ps-4 align-middle">
                            <p className="text-xs mb-0">{index + 1}</p>
                          </td>
                          <td className="align-middle">
                            <p className="text-xs mb-0">
                              {formatDate(withdrawal.RequestDate)}
                            </p>
                          </td>
                          <td className="align-middle">
                            <p className="text-xs mb-0">
                              {withdrawal?.Amount?.toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                              })}
                            </p>
                          </td>
                          <td className="align-middle">
                            <p className="text-xs mb-0">
                              {withdrawal.Remarks || "-"}
                            </p>
                          </td>
                          <td className="align-middle">
                            <span
                              className={`badge badge-lg text-white`}
                              style={{
                                backgroundColor:
                                  withdrawal.WithdrawlStatus === "Pending"
                                    ? "goldenrod"
                                    : withdrawal.WithdrawlStatus === "Rejected"
                                    ? "lightcoral"
                                    : "#00a34de6",
                                padding: "0.35em 0.65em",
                                fontSize: 12,
                              }}
                            >
                              {withdrawal.WithdrawlStatus}
                            </span>
                          </td>
                          <td className="align-middle">
                            <p className="text-xs mb-0">
                              {formatDateTime(withdrawal.WithdrawDate)}
                            </p>
                          </td>
                          <td className="pe-4 d-flex gap-2 align-items-center">
                            <button
                              className="btn btn-sm mb-0 d-flex align-items-center"
                              style={{
                                backgroundColor: "rgba(205, 200, 36, 1)",
                                borderColor: "rgba(205, 200, 36, 1)",
                                color: "#000",
                                padding: "0.25rem 0.8rem",
                              }}
                              onClick={() => {
                                navigate("/walletwithdrawrequestview", {
                                  state: {
                                    ID: withdrawal?.ID,
                                  },
                                });
                              }}
                            >
                              <FaEye className="me-1" /> View
                            </button>
                            {withdrawal.WithdrawlStatus === "Pending" && (
                              <button
                                className="btn btn-sm btn-outline-danger"
                                title="Delete"
                              >
                                <FaTrash size={14} />
                              </button>
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={7} className="text-center py-4">
                          <p className="text-sm text-muted mb-0">
                            No withdrawal history found
                          </p>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default WithdrawalHistory;
